module.exports = __webpack_public_path__ + "img/activitydetail.f9490a54.svg";